module.exports = "https://static-www.niulinkcloud.com/_next/static/media/mobile.07f51ceca1cfbe6a0ce65b2304c74dc2.png";